import { ADMIN_API_ORIGIN } from '@/config/domains';
import api from './api';
import { createComputerReleaseNotesApi } from './computerReleaseNotesClient';

export const computerReleaseNotesApi = createComputerReleaseNotesApi(
  api,
  ADMIN_API_ORIGIN,
);
